// За полной документацией по API, включая примеры кода, зайдите на http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});

export function button144_click(event) {
	$w('#wixChat1').maximize()
	//Add your code for this event here: 
}